import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@veneer/core';
import { useFeatureFlagContext } from '@eu-data-act/react-euda-commons/dist/index';

import { useDependencyManagerContext } from '../contexts/dependencyManager';
import { getUserCleanup, getUserRequest } from '../features/user/user-slice';
import { initializeCachedCategory } from '../utils/cached-category';
import { RootState } from '../store';
import { OperationStatus } from '../types';

import DeviceDetailsViewer from '../components/device-details-viewer';
import DeviceTabs from '../components/device-tabs';
import WelcomeMessage from '../components/welcome-message';
import { Container } from './styled';
import DoNotSeeDevice from '../components/do-not-see-device';

const Router = () => {
  const {
    northboundAPIs: { v1 }
  } = useDependencyManagerContext();
  const { releasePlatformThirdPartySupport } = useFeatureFlagContext();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { user, getUser } = useSelector(
    (state: RootState) => state.UserReducer
  );
  const userEmail = user?.email?.value;

  useEffect(() => {
    if (v1) {
      dispatch(getUserRequest());
    }
    return () => {
      dispatch(getUserCleanup());
    };
  }, [v1, dispatch]);

  useEffect(() => {
    if (getUser.status === OperationStatus.COMPLETED && userEmail) {
      initializeCachedCategory(userEmail);
    }
  }, [getUser.status, userEmail]);

  return (
    <Container $veneerTheme={theme}>
      <WelcomeMessage />
      {releasePlatformThirdPartySupport ? (
        <DeviceTabs />
      ) : (
        <DeviceDetailsViewer />
      )}
      <DoNotSeeDevice />
    </Container>
  );
};

export default memo(Router);
